import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const BillIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.477 19.4601V2H4.52307V19.5067L6.44391 22L7.82426 20.0476L9.20105 21.9964L10.5931 20.0557L11.9618 21.9964L13.3535 20.0557L14.722 21.9964L16.1254 20.0441L17.5093 21.9998L19.477 19.4601ZM14.3524 12.7766C13.8043 13.4084 13.1306 13.7243 12.3314 13.7243C11.829 13.7243 11.3799 13.6102 10.984 13.3818C10.5882 13.1534 10.2837 12.8375 10.0706 12.4341H12.9594V11.475H9.78513C9.77752 11.4065 9.77372 11.3037 9.77372 11.1667C9.77372 11.0297 9.77752 10.9269 9.78513 10.8584H12.9594V9.89929H10.0706C10.2837 9.49586 10.5882 9.17996 10.984 8.9516C11.3799 8.72324 11.829 8.60906 12.3314 8.60906C13.123 8.60906 13.7967 8.92115 14.3524 9.54534L15.5284 8.4492C15.1478 7.99248 14.6759 7.64233 14.1126 7.39874C13.5569 7.15516 12.9327 7.03337 12.24 7.03337C11.5778 7.03337 10.9612 7.15135 10.3903 7.38732C9.827 7.6233 9.34744 7.95823 8.95162 8.39211C8.55579 8.826 8.27034 9.32839 8.09526 9.89929H6.80502V10.8584H7.92399C7.91638 10.9269 7.91257 11.0297 7.91257 11.1667C7.91257 11.3037 7.91638 11.4065 7.92399 11.475H6.80502V12.4341H8.09526C8.27034 13.005 8.55579 13.5074 8.95162 13.9413C9.34744 14.3752 9.827 14.7101 10.3903 14.9461C10.9612 15.182 11.5778 15.3 12.24 15.3C12.9327 15.3 13.5569 15.1782 14.1126 14.9347C14.6759 14.6911 15.1478 14.3371 15.5284 13.8728L14.3524 12.7766Z'
                fill='currentColor'
            />
        </>
    ),
})

BillIcon.displayName = 'BillIcon'
